import request from '../untils/request';

export const evaluateListApi = params => {
  return request({
    url: '/order/evaluate/index',
    params,
    AathCode: 'EVALUATE_INDEX',
  });
};

export const evaluateVerifyApi = params => {
  return request({
    url: '/order/evaluate/verify',
    AathCode: 'EVALUATE_EDIT',
    params,
  });
};

export const appShowApi = params => {
  return request({
    url: '/order/evaluate/app-show',
    params,
    AathCode: 'EVALUATE_EDIT',
  });
};

export const allShowApi = params => {
  return request({
    url: '/order/evaluate/all-show',
    params,
    AathCode: 'EVALUATE_EDIT',
  });
};

export const evaluateDeleteApi = params => {
  return request({
    url: '/order/evaluate/delete',
    params,
    AathCode: 'EVALUATE_EDIT',
  });
};

export const deliverRemindApi = params => {
  return request({
    url: '/order/deliver-remind/index',
    params,
    AathCode: 'DELIVER-REMIND_INDEX',
  });
};

export const deliverRemindDeleteApi = params => {
  return request({
    url: '/order/deliver-remind/delete',
    params,
    AathCode: 'DELIVER-REMIND_INDEX',
  });
};

export const refundReasonApi = params => {
  return request({
    url: '/order/refund-reason/index',
    params,
    AathCode: 'REFUND-REASON_INDEX',
  });
};

export const createRefundReasonApi = params => {
  return request({
    url: '/order/refund-reason/create',
    params,
    AathCode: 'REFUND-REASON_EDIT',
  });
};

export const updateRefundReasonApi = params => {
  return request({
    url: '/order/refund-reason/update',
    params,
    AathCode: 'REFUND-REASON_EDIT',
  });
};

export const deleteRefundReasonApi = params => {
  return request({
    url: '/order/refund-reason/delete',
    params,
    AathCode: 'REFUND-REASON_EDIT',
  });
};

export const orderLogsApi = params => {
  return request({
    url: '/order/order/logs',
    params,
    AathCode: 'ORDER_LOGS',
  });
};

